var map = {
	"./A_rare_silk_nearly_lost_through_war.jpg": 3581,
	"./AdefiantmovetotheNorwegianArctic.jpg": 7934,
	"./AhypnoticSwedishtradition.jpg": 9351,
	"./Anationwithoutaccesstoitsownsea.jpg": 1255,
	"./AtightlyguardedHimalayansecret.jpg": 4842,
	"./Atinyislewithanunspokenlanguage.jpg": 3040,
	"./Canadas-rising-Inuit-TikTok-star.jpg": 832,
	"./Chileshiddenkingdomoffungi.jpg": 2921,
	"./HongKongsguardianofthegods.jpg": 6367,
	"./MachuPicchustrailblazingwomen.jpg": 7099,
	"./Malaysiashumblekingofnoodles.jpg": 8715,
	"./New_Zealands_feisty_feathered_patient.jpg": 5694,
	"./Onevillagesdramatictransformation.jpg": 2182,
	"./ScotlandslittleknownHighlanders.jpg": 1515,
	"./Spainsunderwatersuperplant.jpg": 415,
	"./The-US-remote-northernoutpost.jpg": 7236,
	"./The-world-traveller-who-never-left-home.jpg": 3269,
	"./TheBahamasqueenofJunkanoo.jpg": 7402,
	"./TheEuropeannationkeepingusyoung.jpg": 3285,
	"./TheIndianaJonesoftheCaribbean.jpg": 4031,
	"./TheRussiantownbuiltbyapples.jpg": 6049,
	"./ThechefwhoputSloveniaonthemap.jpg": 4833,
	"./Thecouscousmealthatfeedsgenerosity.jpg": 5933,
	"./TheguardianofColoradosFrontRange.jpg": 4314,
	"./Theindigenousrecipeforlivingwell.jpg": 411,
	"./Themanpreservingendangeredcolours.jpg": 8203,
	"./Theposterboyofzero-wasteliving.jpg": 7302,
	"./ThesacredPolynesianartofwayfinding.jpg": 6831,
	"./Wherepeoplegotobarstodrinkmilk.jpg": 6671,
	"./Zimbabwesreverednestcustodians.jpg": 9046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6193;